import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listBranches, type Branch } from './api';
import { useAuthStore } from './auth-store';

/**
 * Shared branch context for cashier-area pages. A scoped cashier is pinned to
 * their own branch (no picker); an admin / super_admin picks from the list and
 * defaults to the first branch. Mirrors the inline logic the POS page uses.
 */
export function useActiveBranch() {
  const user = useAuthStore((s) => s.user);
  const branchesQuery = useQuery({ queryKey: ['branches'], queryFn: listBranches });
  const [selectedBranchId, setSelectedBranchId] = useState<string | null>(user?.branchId ?? null);

  useEffect(() => {
    const first = branchesQuery.data?.[0];
    if (!selectedBranchId && first) setSelectedBranchId(first.id);
  }, [branchesQuery.data, selectedBranchId]);

  const branchId = user?.branchId ?? selectedBranchId;
  const isScoped = !!user?.branchId;
  const branches: Branch[] = branchesQuery.data ?? [];

  return { branchId, setSelectedBranchId, isScoped, branches };
}
